import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import {
  UPLOAD_RESPONSE_MESSAGES,
  UPLOAD_RESPONSE_PATTERNS,
} from '@/shared/constants/file-upload.constants';

interface ProcessedResponseCounts {
  processedCount: number;
  failedCount: number;
  skippedCount: number;
}

export const processUploadResponseMessage = (message: string): ProcessedResponseCounts => {
  const processedMatch = message.match(UPLOAD_RESPONSE_PATTERNS.PROCESSED);
  const failedMatch = message.match(UPLOAD_RESPONSE_PATTERNS.FAILED);
  const skippedMatch = message.match(UPLOAD_RESPONSE_PATTERNS.SKIPPED);

  const processedCount = processedMatch ? parseInt(processedMatch[1], 10) : 0;
  const failedCount = failedMatch ? parseInt(failedMatch[1], 10) : 0;
  const skippedCount = skippedMatch ? parseInt(skippedMatch[1], 10) : 0;

  return {
    processedCount,
    failedCount,
    skippedCount,
  };
};

export const parseUploadResponse = (
  processedResponse: ProcessedResponseCounts,
  filename: string,
) => {
  const { processedCount, failedCount, skippedCount } = processedResponse;
  try {
    if (processedCount > 0) {
      notificationService.showSuccess(UPLOAD_RESPONSE_MESSAGES.PROCESSED(filename));
    }

    if (failedCount > 0) {
      notificationService.showError(UPLOAD_RESPONSE_MESSAGES.FAILED(filename));
    }

    if (skippedCount > 0) {
      notificationService.showInfo(UPLOAD_RESPONSE_MESSAGES.SKIPPED(filename));
    }

    if (failedCount === 0 && processedCount === 0 && skippedCount === 0) {
      notificationService.showInfo(UPLOAD_RESPONSE_MESSAGES.NO_FILES_PROCESSED);
    }
  } catch (error) {
    notificationService.showInfo(
      i18n.t('knowledge:knowledgeBases.parseUploadResponse.uploadFailed', {
        message:
          error instanceof Error
            ? error.message
            : i18n.t('knowledge:knowledgeBases.parseUploadResponse.unknownError'),
      }),
    );
  }
};
